"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdPaginator = _interopRequireDefault(require("cccisd-paginator"));
var _courseDataAndProgress = _interopRequireDefault(require("./Course/courseDataAndProgress.graphql"));
var _sharedRegistrationProgress = _interopRequireDefault(require("./Course/sharedRegistrationProgress.graphql"));
var _Course = require("./Course");
var _productData = _interopRequireDefault(require("./Product/productData.graphql"));
var _FilterSideBar = _interopRequireDefault(require("./FilterSideBar"));
var _ListView = _interopRequireDefault(require("./ResourceLists/ListView"));
var _GridView = _interopRequireDefault(require("./ResourceLists/GridView"));
var _ListViewCover = _interopRequireDefault(require("./ResourceLists/ListViewCover"));
var _GridViewCover = _interopRequireDefault(require("./ResourceLists/GridViewCover"));
var _FilterTabBar = _interopRequireDefault(require("./FilterTabBar"));
var _TopFilterBar = _interopRequireDefault(require("./TopFilterBar"));
var _grid = _interopRequireDefault(require("cccisd-icons/grid6"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _info = _interopRequireDefault(require("cccisd-icons/info"));
var _style = _interopRequireDefault(require("./style.css"));
var _class;
var _excluded = ["forwardedRef"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var withRouterForwardRef = function withRouterForwardRef(Component) {
  var WithRouter = (0, _reactRouterDom.withRouter)(function (_ref) {
    var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      ref: forwardedRef
    }, props));
  });
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(WithRouter, _extends({}, props, {
      forwardedRef: ref
    }));
  });
};
/** Component for individual resource tab. Allows searching, and filtering. */
var _default = withRouterForwardRef((_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ResourcePortal, _React$Component);
  var _super = _createSuper(ResourcePortal);
  function ResourcePortal() {
    var _this;
    _classCallCheck(this, ResourcePortal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      search: '',
      filters: [],
      session: 'All',
      perPage: 10,
      currentPage: 1,
      renderMode: 'list',
      isMobile: false,
      data: null,
      dataByTab: null
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.displayOptions.portal && _this.props.displayOptions.portal.defaultPerPageOption) {
        _this.updatePerPage(_this.props.displayOptions.portal.defaultPerPageOption);
      }
      _this.getData();
      window.addEventListener('resize', _this.checkIfMobile);
      _this.setState({
        renderMode: _this.props.displayOptions.resources.renderMode
      });
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.currentTab !== _this.props.currentTab) {
        _this.setState({
          currentPage: 1
        });
        _this.getData();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, data, windowSearch, params, allTagQueries, deploymentIds, result, deploymentData, childDeploymentData, depSharedRegistrationMap, sharedRegistrationData, sharedRegistrationResp, productIds, _result, productData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _cccisdAxios["default"].get(Boilerplate.route('api.resources.resource.index'), {
                params: {
                  scope: _this.props.id
                }
              });
            case 2:
              response = _context.sent;
              data = response.data.data;
              windowSearch = window.location.search.slice(1);
              params = new URLSearchParams(windowSearch);
              allTagQueries = params.getAll('tag');
              /* Course Data */
              deploymentIds = data.filter(function (resource) {
                return resource.type === 'course';
              }).map(function (resource) {
                var metadata = JSON.parse(resource.published_metadata) || {};
                return metadata.deploymentId;
              });
              if (!(deploymentIds.length > 0)) {
                _context.next = 23;
                break;
              }
              _context.next = 11;
              return _cccisdApollo.client.query({
                query: _courseDataAndProgress["default"],
                variables: {
                  deploymentIds: deploymentIds,
                  pawnId: Fortress.auth() ? Fortress.user.acting.id : 0
                },
                fetchPolicy: 'network-only'
              });
            case 11:
              result = _context.sent;
              deploymentData = (0, _get2["default"])(result, 'data.flows.deploymentList', []) || [];
              childDeploymentData = (0, _get2["default"])(result, 'data.flows.childDeployments', []) || [];
              depSharedRegistrationMap = {};
              deploymentData.forEach(function (d) {
                var sharedRegistrationId = (0, _get2["default"])(d, 'assignment.settings.navigationSettings.registration.toggle', false) === true && (0, _get2["default"])(d, 'assignment.settings.navigationSettings.registration.isExternalRegistration', false) === true && (0, _get2["default"])(d, 'assignment.settings.navigationSettings.registration.externalRegistrationDeploymentId', false);
                sharedRegistrationId = parseInt(sharedRegistrationId, 10);
                if (Number.isInteger(sharedRegistrationId)) {
                  depSharedRegistrationMap[d.deploymentId] = sharedRegistrationId;
                }
              });
              sharedRegistrationData = {};
              if (!(Object.keys(depSharedRegistrationMap).length > 0)) {
                _context.next = 22;
                break;
              }
              _context.next = 20;
              return _cccisdApollo.client.query({
                query: _sharedRegistrationProgress["default"],
                variables: {
                  deploymentIds: Object.values(depSharedRegistrationMap),
                  pawnId: Fortress.auth() ? Fortress.user.acting.id : 0
                },
                fetchPolicy: 'network-only'
              });
            case 20:
              sharedRegistrationResp = _context.sent;
              sharedRegistrationData = ((0, _get2["default"])(sharedRegistrationResp, 'data.flows.deploymentList', []) || []).reduce(function (allData, curr) {
                allData[curr.deploymentId] = curr.assignmentProgress;
                return allData;
              }, {});
            case 22:
              data = data.map(function (resource) {
                if (resource.type === 'course') {
                  var _resource, _resource$courseData;
                  var metadata = JSON.parse(resource.published_metadata) || {};
                  resource.courseData = deploymentData.find(function (d) {
                    return Number.parseInt(d.deploymentId, 10) === Number.parseInt(metadata.deploymentId, 10);
                  }) || {};
                  resource.childDeploymentData = childDeploymentData.filter(function (d) {
                    return Number.parseInt(d.parentDeploymentId, 10) === Number.parseInt(metadata.deploymentId, 10);
                  }) || {};
                  var sharedRegistrationId = depSharedRegistrationMap[(_resource = resource) === null || _resource === void 0 ? void 0 : (_resource$courseData = _resource.courseData) === null || _resource$courseData === void 0 ? void 0 : _resource$courseData.deploymentId];
                  resource.sharedRegistrationData = sharedRegistrationData[sharedRegistrationId];
                  resource = _objectSpread(_objectSpread({}, resource), (0, _Course.setAssignmentProgress)(resource));
                }
                return resource;
              });
            case 23:
              /* Product Data */
              productIds = data.filter(function (resource) {
                return resource.type === 'product';
              }).map(function (resource) {
                return resource.product_id;
              });
              if (!(productIds.length > 0)) {
                _context.next = 30;
                break;
              }
              _context.next = 27;
              return _cccisdApollo.client.query({
                query: _productData["default"],
                variables: {
                  productIds: productIds,
                  pawnId: Fortress.auth() ? Fortress.user.acting.id : 0
                },
                fetchPolicy: 'network-only'
              });
            case 27:
              _result = _context.sent;
              productData = (0, _get2["default"])(_result, 'data.products.productList', []);
              data = data.map(function (resource) {
                if (resource.type === 'product') {
                  resource.productData = productData.find(function (d) {
                    return Number.parseInt(d.productId, 10) === resource.product_id;
                  }) || {};
                  var licenseStatus = (0, _get2["default"])(resource, 'productData.licenseStatus', 'none') || 'none';
                  resource.hasProductBeenOwned = licenseStatus === 'active' || licenseStatus === 'expired';
                }
                return resource;
              });
            case 30:
              _this.setState({
                filters: allTagQueries,
                loading: false,
                data: data,
                dataByTab: data.filter(function (d) {
                  return Object.values(d.tag_handles).includes(_this.props.currentTab);
                }),
                currentTab: _this.props.currentTab
              });
            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "checkIfMobile", function () {
      var isMobile = window.innerWidth < 768;
      if (isMobile !== _this.state.isMobile) {
        _this.setState({
          isMobile: isMobile
        });
      }
      if (isMobile) {
        _this.setState({
          renderMode: 'list'
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_compareArrays", function (arr1, arr2) {
      return arr2.filter(function (e) {
        return arr1.includes(e);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_areHexCodesEqual", function (hex1, hex2) {
      if (hex1 && hex2 && hex1.length !== hex2.length) {
        hex1 = hex1.length === 4 ? hex1.replace(/#(.)(.)(.)/, '#$1$1$2$2$3$3') : hex1;
        hex2 = hex2.length === 4 ? hex2.replace(/#(.)(.)(.)/, '#$1$1$2$2$3$3') : hex2;
      }
      return hex1 === hex2;
    });
    _defineProperty(_assertThisInitialized(_this), "getFilteredData", function () {
      var _this$state = _this.state,
        search = _this$state.search,
        data = _this$state.data,
        session = _this$state.session,
        filters = _this$state.filters;
      var currentTab = _this.props.currentTab;

      // build object of activeFilters in realation to their groups
      function includes(obj, val) {
        obj = obj || {};
        return Object.keys(obj).some(function (k) {
          return obj[k] === val;
        });
      }
      var activeFilters = {};
      var activeGroups = _this.props.filterGroups.filter(function (group) {
        return group.tags.some(function (tag) {
          return filters.includes(tag);
        });
      });
      for (var i = 0; i < activeGroups.length; i++) {
        var group = activeGroups[i];
        var activeTags = group.tags.filter(function (tag) {
          return filters.includes(tag);
        });
        activeFilters[group.name] = activeTags;
      }

      // filter data based on active filters
      if (filters.length > 0) {
        data = data.filter(function (item) {
          return Object.keys(activeFilters).every(function (group) {
            return activeFilters[group].some(function (tag) {
              return includes(item.tag_handles, tag);
            });
          });
        });
      }
      if (currentTab !== 'All') {
        data = data.filter(function (item) {
          return includes(item.tag_handles, currentTab);
        });
      }
      if (session !== 'All') {
        data = data.filter(function (item) {
          return includes(item.tag_handles == null ? [] : item.tag_handles, session);
        });
      }
      if (search !== '') {
        // apply search
        var lowerCaseSearch = search.toLowerCase();
        data = data.filter(function (item) {
          if (item.published_label !== null && item.published_label.toLowerCase().includes(lowerCaseSearch) || item.published_description !== null && item.published_description.toLowerCase().includes(lowerCaseSearch) || item.search_terms !== null && item.search_terms.some(function (term) {
            return term.toLowerCase().includes(lowerCaseSearch);
          })) {
            return true;
          }
          var metadata = JSON.parse(item.published_metadata) || {};
          var courseDescription = item.type === 'course' && (metadata.showMainIntroduction || metadata.showCourseSectionHeaders) && (0, _get2["default"])(item, 'courseData.assignment.settings.navigationSettings.courseDescription');
          if (!courseDescription) {
            return false;
          }
          var tmpMainIntro = (0, _get2["default"])(courseDescription, 'introduction.main', '');
          var tmpCourseHeaders = (0, _get2["default"])(courseDescription, 'introduction.courseSections', []).map(function (s) {
            return s.heading;
          });
          if (metadata.showMainIntroduction && tmpMainIntro.toLowerCase().includes(lowerCaseSearch)) {
            return true;
          }
          return metadata.showCourseSectionHeaders && tmpCourseHeaders.some(function (h) {
            return h.toLowerCase().includes(lowerCaseSearch);
          });
        });
      }

      // Set icons for each resource
      data = data.map(function (item) {
        var resourceTagsKeys = Object.keys(item.tag_handles || {});
        var resourceTagsArr = resourceTagsKeys.map(function (tagKey) {
          return item.tag_handles[tagKey];
        });
        item.icons = [];
        _this.props.filterGroups.forEach(function (filterGroup) {
          if (_this._compareArrays(filterGroup.tags, resourceTagsArr.map(function (j) {
            return j + ' (' + _this.props.id + ')';
          })).length > 0) {
            if (filterGroup.icon) {
              item.icons.push({
                name: filterGroup.icon,
                color: filterGroup.color
              });
            }
          }
        });
        return item;
      });
      return data.sort(function (a, b) {
        if (a.handle.toLowerCase() < b.handle.toLowerCase()) {
          return -1;
        }
        if (a.handle.toLowerCase() > b.handle.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getDataForPage", function (data) {
      return data.slice((_this.state.currentPage - 1) * _this.state.perPage, (_this.state.currentPage - 1) * _this.state.perPage + _this.state.perPage);
    });
    _defineProperty(_assertThisInitialized(_this), "searchHandler", function (event) {
      _this.setState({
        search: event.target.value,
        currentPage: 1
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updateSession", function (session) {
      _this.setState({
        session: session,
        currentPage: 1
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updatePerPage", function (value) {
      _this.setState({
        perPage: value,
        currentPage: 1
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onPageChange", function (page) {
      _this.setState({
        currentPage: page
      });
    });
    _defineProperty(_assertThisInitialized(_this), "clearSearch", function () {
      _this.setState({
        search: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "clearFilters", function () {
      _this.setState({
        filters: []
      });
      var params = new URLSearchParams(window.location.search.slice(1));
      var tabQuery = params.get('tab') || _this.props.currentTab;
      window.history.replaceState({
        page: 1
      }, '', "".concat(window.location.pathname, "?tab=").concat(tabQuery));
    });
    _defineProperty(_assertThisInitialized(_this), "updateFilters", function (id) {
      _this.setState(function (prevState) {
        return {
          filters: prevState.filters.includes(id) ? prevState.filters.filter(function (item) {
            return item !== id;
          }) : [].concat(_toConsumableArray(prevState.filters), [id]),
          currentPage: 1
        };
      });

      /* Append URL with tag query strings */
      var params = new URLSearchParams(window.location.search.slice(1));
      var tabQuery = params.get('tab') || _this.props.currentTab;
      var tagQueryString = '';
      var allTagQueries = params.getAll('tag');
      var newTagQueries = (0, _xor2["default"])(allTagQueries, [id]);
      var _iterator = _createForOfIteratorHelper(newTagQueries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tagQuery = _step.value;
          tagQueryString += "&tag=".concat(tagQuery);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      window.history.pushState({
        page: 1
      }, '', "".concat(window.location.pathname, "?tab=").concat(tabQuery).concat(tagQueryString));
    });
    _defineProperty(_assertThisInitialized(_this), "renderDefaultResourceTiles", function (renderProps) {
      if (_this.state.renderMode === 'list') {
        return _this.props.displayOptions.resources.coverThumbnails ? /*#__PURE__*/_react["default"].createElement(_ListViewCover["default"], renderProps) : /*#__PURE__*/_react["default"].createElement(_ListView["default"], renderProps);
      }
      return _this.props.displayOptions.resources.coverThumbnails ? /*#__PURE__*/_react["default"].createElement(_GridViewCover["default"], renderProps) : /*#__PURE__*/_react["default"].createElement(_GridView["default"], renderProps);
    });
    _defineProperty(_assertThisInitialized(_this), "returnResult", function (dataForPage) {
      var renderResourceTiles = _this.props.renderResourceTiles;
      var commonViewProps = {
        displayOptions: _this.props.displayOptions.resources,
        getShareUrl: _this.getShareUrl,
        currentTab: _this.props.currentTab,
        data: dataForPage
      };
      if (dataForPage.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("h1", {
          className: _style["default"].noResult
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], null), " No results found.");
      }
      if (renderResourceTiles) {
        return renderResourceTiles(commonViewProps, _this.renderDefaultResourceTiles);
      }
      return _this.renderDefaultResourceTiles(commonViewProps);
    });
    _defineProperty(_assertThisInitialized(_this), "getShareUrl", function (tab, resource) {
      var base = _this.props.match.path.replace(/^([^:]*)(.*)/, '$1');
      var prefix = base.endsWith('/') ? '' : '/';
      var url = Boilerplate.url("".concat(base).concat(prefix).concat(tab, "/").concat(resource.id));
      return url;
    });
    _defineProperty(_assertThisInitialized(_this), "hasCustomStyles", function (attribute) {
      var hasStyles = _this.props.displayOptions && _this.props.displayOptions.portal;
      return hasStyles && _this.props.displayOptions.portal[attribute];
    });
    return _this;
  }
  _createClass(ResourcePortal, [{
    key: "switchResourceRenderMode",
    value: function switchResourceRenderMode(mode) {
      this.setState({
        renderMode: mode
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.state.loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var displayOptions = this.props.displayOptions;
      var data = this.getFilteredData();
      var dataForPage = this.getDataForPage(data);
      var searchBarColorMatchesBackground = this._areHexCodesEqual((0, _get2["default"])(displayOptions, 'portal.backgroundColor'), (0, _get2["default"])(displayOptions, 'portal.searchBarColor'));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('row', _style["default"].container),
        style: this.hasCustomStyles('backgroundColor') ? {
          backgroundColor: displayOptions.portal.backgroundColor
        } : {}
      }, this.props.filterGroups.length !== 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('col-sm-3', _style["default"].sidebar)
      }, /*#__PURE__*/_react["default"].createElement(_FilterSideBar["default"], {
        filterGroups: this.props.filterGroups,
        filterTags: this.props.tags,
        filters: this.state.filters,
        filterUpdater: this.updateFilters,
        displayOptions: displayOptions
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.filterGroups.length !== 0 ? 'col-sm-9' : 'col-sm-12', _style["default"].noTopMargin, _style["default"].noPadding, _style["default"].results),
        style: {
          paddingLeft: this.props.filterGroups.length === 0 ? 0 : null
        }
      }, this.props.topFilterBar && /*#__PURE__*/_react["default"].createElement(_TopFilterBar["default"], {
        topFilterBar: this.props.topFilterBar,
        tags: this.props.tags,
        filterUpdater: this.updateSession
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('navbar navbar-inverse', _style["default"].searchbarGroup),
        style: {
          backgroundColor: this.hasCustomStyles('searchBarColor') && displayOptions.portal.searchBarColor,
          display: displayOptions.resources.showPageControls === false || displayOptions.resources.hideDisplayLayoutToggle && displayOptions.resources.hideSearchBar ? 'none' : null,
          padding: this.props.showTabs || !searchBarColorMatchesBackground ? '1rem 0 0 0' : '0px'
        }
      }, !this.state.isMobile && !displayOptions.resources.hideDisplayLayoutToggle && /*#__PURE__*/_react["default"].createElement("form", {
        className: (0, _classnames["default"])('btn-group', _style["default"].noPadding),
        style: {
          marginLeft: searchBarColorMatchesBackground ? '0px' : '1.2rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick(e) {
          return _this2.switchResourceRenderMode('grid');
        },
        className: (0, _classnames["default"])('btn btn-default', this.state.renderMode === 'grid' ? 'active ' : '')
      }, /*#__PURE__*/_react["default"].createElement(_grid["default"], null)), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick(e) {
          return _this2.switchResourceRenderMode('list');
        },
        className: (0, _classnames["default"])('btn btn-default ', this.state.renderMode === 'list' ? 'active ' : '')
      }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))), !displayOptions.resources.hideSearchBar && /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
        },
        className: (0, _classnames["default"])('pull-right', _style["default"].noPadding),
        style: {
          marginRight: searchBarColorMatchesBackground ? '0px' : '1.2rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _style["default"].wrapper, this.state.search && _style["default"].withData)
      }, /*#__PURE__*/_react["default"].createElement("input", {
        ref: function ref(input) {
          _this2.input = input;
        },
        type: "text",
        placeholder: "Search",
        value: this.state.search,
        onChange: this.searchHandler,
        className: "form-control"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, this.state.search ? /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-remove",
        onClick: this.clearSearch
      }) : /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-search"
      }))))), /*#__PURE__*/_react["default"].createElement(_FilterTabBar["default"], {
        filters: this.props.tags.filter(function (item) {
          return _this2.state.filters.includes(item.name);
        }),
        removeFilter: this.updateFilters,
        removeAllFilters: this.clearFilters
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('row ', _style["default"].pageData),
        style: {
          display: displayOptions.resources.showPageControls === false || displayOptions.resources.hideShowingResources && displayOptions.resources.hidePerPageDropdown ? 'none' : null
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('col-sm-8', _style["default"].noPadding)
      }, !displayOptions.resources.hideShowingResources && /*#__PURE__*/_react["default"].createElement("h3", {
        className: _style["default"].resourceCount,
        style: this.hasCustomStyles('resourceCountLabelColor') ? {
          color: displayOptions.portal.resourceCountLabelColor
        } : {}
      }, "Showing ", data.length, " of ", this.state.dataByTab.length, " resources.")), this.props.displayOptions.portal && (!this.props.displayOptions.portal.perPageOptions || this.props.displayOptions.portal.perPageOptions.length !== 0) && !displayOptions.resources.hidePerPageDropdown && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('col-sm-4', _style["default"].perPageWrapper, _style["default"].noPadding)
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "per-page",
        className: "control-label"
      }, "Per page:"), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        onChange: function onChange(e) {
          return _this2.updatePerPage(Number(e.target.value));
        },
        value: this.state.perPage,
        name: "per-page",
        style: {
          width: 'auto'
        }
      }, this.props.displayOptions.portal && this.props.displayOptions.portal.perPageOptions ? this.props.displayOptions.portal.perPageOptions.map(function (perPage) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: perPage
        }, perPage);
      }) : [5, 10, 25, 50].map(function (perPage) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: perPage
        }, perPage);
      })))), this.returnResult(dataForPage), /*#__PURE__*/_react["default"].createElement(_cccisdPaginator["default"], {
        className: "pull-right",
        currentPage: this.state.currentPage,
        total: Math.ceil(data.length / this.state.perPage),
        onPageChange: this.onPageChange
      })));
    }
  }]);
  return ResourcePortal;
}(_react["default"].Component), _defineProperty(_class, "propTypes", {
  id: _propTypes["default"].string,
  currentTab: _propTypes["default"].string,
  topFilterBar: _propTypes["default"].object,
  filterGroups: _propTypes["default"].array,
  data: _propTypes["default"].array,
  tags: _propTypes["default"].array,
  displayOptions: _propTypes["default"].object,
  match: _propTypes["default"].object,
  renderResourceTiles: _propTypes["default"].func,
  showTabs: _propTypes["default"].bool
}), _class));
exports["default"] = _default;